import React, { Component } from 'react';
import { APP_PATHS } from '../utils/appPaths.js';
import { Link } from 'react-router-dom';
import { Container, Button } from "reactstrap";
import { BACK_TO_HOME_PAGE } from "../Constant";

const SimpleError500 = () => (
    <div className="page-wrapper">
        <div className="error-wrapper">
            <Container>
                <div className="text-center">
                    <h1 className="display-1 text-danger">500</h1>
                    <h2 className="mb-4">Something went wrong</h2>
                    <p className="mb-4">
                        The page you are attempting to reach is currently not available. 
                        This may be because the page does not exist or has been moved.
                    </p>
                    <Link to={APP_PATHS.dashboard}>
                        <Button color="primary" size="lg">
                            {BACK_TO_HOME_PAGE}
                        </Button>
                    </Link>
                </div>
            </Container>
        </div>
    </div>
);

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <SimpleError500 />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;